import React from 'react';
// import axios from 'axios';
// import urlBase from '../../url-base';


class GetSalesmanLinkSite extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      
    };
  }

  componentDidMount() {
    // let linkSite = window.location.href.split(urlBase.client);
    // if (linkSite[1].length > 0) {
    //   axios.get(urlBase.loopBack + 'Salesmans?filter={"where":{"linkSite":"' + linkSite[1] + '"},"include":"user"}')
    //   .then((result) => {
    //     if (result.data.length > 0 && result.data[0].user.active == true) {
    //       localStorage.setItem('dental_v_i', result.data[0].id);
    //       localStorage.setItem('dental_v_name', result.data[0].user.name);
          
    //       if(result.data[0].pagSeguroToken == '' || result.data[0].pagSeguroEmail == ''){
    //         localStorage.setItem('dental_v_ps', false);
    //       }else{
    //         localStorage.setItem('dental_v_ps', true);
    //       }
    //     }
    //     else {
    //       if (localStorage.getItem('dental_v_i') == null || localStorage.getItem('dental_v_i').length == 0) {
    //         axios.get(urlBase.loopBack + 'Salesmans?filter={"where":{"linkSite":"dental-center"}}')
    //         .then((result) => {
    //           localStorage.setItem('dental_v_i', result.data[0].id);
    //           localStorage.setItem('dental_v_name', result.data[0].user.name);
    //           if(result.data[0].pagSeguroToken == '' || result.data[0].pagSeguroEmail == ''){
    //             localStorage.setItem('dental_v_ps', false);
    //           }else{
    //             localStorage.setItem('dental_v_ps', true);
    //           }

    //         })
    //         .catch(function () {
    //           alert('Problema encontrado ao buscar dados do vendedor');
    //         });
    //       }

    //     }
    //   })
    //   .catch(function () {
    //     alert('Problema encontrado ao buscar dados do vendedor');
    //   });
    // }
    // else {
    //   if (localStorage.getItem('dental_v_i') == null || localStorage.getItem('dental_v_i').length == 0) {
    //     axios.get(urlBase.loopBack + 'Salesmans?filter={"where":{"linkSite":"dental-center"}}')
    //     .then((result) => {
    //       localStorage.setItem('dental_v_i', result.data[0].id);
    //     })
    //     .catch(function () {
    //       alert('Problema encontrado ao buscar dados do vendedor');
    //     });
    //   }
    // }
  }

  render() {

    return (
      <div>&nbsp;</div>
    );

  }

}

export default GetSalesmanLinkSite;



/** WEBPACK FOOTER **
 ** ./src/components/HomePageNew/GetSalesmanLinkSite.js
 **/